import { createFileRoute } from '@tanstack/react-router';
import { ObjectRelationshipsTab } from '@/pages/workspaces/objects/object-detail/object-relationships-tab';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/relationships')({
  component: withRumPageRendered(ObjectRelationshipsTab),
});
